import { useMemo } from 'react';
import { getAccessToken, parseJwt } from '@blocs.auth';
import { gqlSystemRoleCode } from '@minecraft.graphql-types';

const useSystemRole = (): gqlSystemRoleCode => {
  const token = getAccessToken();

  return useMemo(() => parseJwt(token)?.role?.code || '', [token]);
};

/**
 * @deprecated use PermissionsProvider instead
 * if you are checking for isCD or isPC you can use
 * ability.can('publish', 'role') for isCD
 * ability.can('request-approval', 'role') for isPC
 */
export default useSystemRole;
